<template>
	<div class="system-website">
		<section>
			<h1>接入官网的方式</h1>
			<p>通过对桌面/手机网站的部署网页组件和聊天方式的链接，即可进入到OCS+客服。</p>
			<p><i>*</i> 完成部署后，客户可直接在您的桌面网站发起咨询，接入过程中若遇到问题，请参考<a href="www.baidu.com" target="_blank">OCS+客服网页端接入文档</a>
			</p>
		</section>
		<section>
			<h1>网站接入列表</h1>
			<el-button type="primary" icon="el-icon-plus" size="mini" @click="onAdd">添加网站</el-button>
			<table-pagination v-loading="loading" style="margin-top: 22px;" ref="tableItem" pagination
				layout="prev,pager,next,total" :data="data" :column="column" :total="total"
				:page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize" @pagination="getList">
				<template v-slot:enabled="{row}">
					<div class="operate-inline">
						<el-switch v-model="row.enabled" @change='(val)=>handleSwitchChange(val,row)'>
						</el-switch>
					</div>
				</template>
			</table-pagination>
		</section>
		<!-- 添加、编辑网站 -->
		<Detail ref="detail" :title="title"></Detail>
		<!-- 部署配置 -->
		<Dispose ref="dispose"></Dispose>
	</div>
</template>
<script>
	import Dispose from './dispose';
	import Detail from './detail'
	import { mapGetters } from "vuex";
	export default {
		components: {
			Dispose,
			Detail
		},
		computed:{
			 ...mapGetters([
				'subBrandList',
				'skillGroupLists'
			])
		},
		data() {
			return {
				title:'添加网站',
				loading: false,
				data: [
					{name:'测试001',remark:'dsafgjasdfasdf',date:'2020-02-16 14:56:12',skillGroup:'哈哈哈',enabled:true}
				],
				column: [{
						label: "网站名称",
						prop: "name"
					},
					{
						label: "备注",
						prop: "remark"
					},
					{
						label: '更新时间',
						prop: 'date',
						sortable: true
					},
					{
						label: "授权技能组",
						prop: "skillGroup",
						filters:[],
						filterMultiple:false,
						filterMethod: (value, row, column) => {
							return true
						}
					},
					{
						label: "操作",
						prop: "cation",
						align: "center",
						width: 200,
						render: (h, scope) => {
							return (
								<div class="operate-inline">
									<el-button type="text" size="small" onClick={() => this.onDispose(scope.row)}>新建部署</el-button>
									<el-divider direction="vertical"></el-divider>
									<el-button type="text" size="small" onClick={() => this.onEdit(scope.row)}>编辑</el-button>
								</div>
							);
						}

					},
					{
						label: "开关",
						prop: "enabled",
						align: "center",
						slotScope: true,
						width: 200,
					}
				],
				total: 0,
				listQuery: {
					pageNum: 1,
					pageSize: 10,
				}
				
			}
		},
		methods: {
			getList() {

			},
			onAdd(){
				this.$refs.detail.openDetail()
				this.title = '添加网站'
			},
			onDispose() {
				this.$refs.dispose.openDispose()
			},
			onEdit() {
				this.$refs.detail.openDetail()
				this.title = '编辑网站'
			},
			handleSwitchChange(val,row){
				let title = row.enabled ? '恢复' : '禁用';
				let desc = row.enabled ? '恢复后将继续接收该网站得消息，是否继续？' : '禁用添加的桌面网站后，在“（网站名称）”将无法接受咨询，是否要禁用该网站？*禁用后仍可恢复'
				this.$confirm(desc, `${title}提醒`, {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
						center: true,
						customClass: "confirm-element-model"
					})
					.then(() => {
						this.$message.success(`${title}成功`)
						
					})
					.catch(() => {
						this.$message.info(`取消${title}`)
						row.enabled = true
					});
			}
		},
		created(){
			let result = []
			 this.skillGroupLists.map(item => {
				result.push({
					text:item.name,
					value:item.id
				})
			})
			this.column[3].filters = result
		}
	}
</script>
<style lang="scss" scoped>
	.system-website {
		font-size: 14px;

		h1 {
			color: #3C4353;
			margin-bottom: 16px;
			font-size: 14px;
		}

		p {
			color: #566980;
			line-height: 22px;

			&:nth-of-type(2) {
				color: #A6AAB8;

				i {
					color: #FF504D;
				}

				a {
					color: #337EFF;
				}
			}
		}

		>section {
			&:nth-of-type(2) {
				margin-top: 30px;
			}
		}
	}
</style>
